/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_R_AboutInputs */

const en_mk_nav_r_about = /** @type {(inputs: Mk_Nav_R_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About us`)
};

const id_mk_nav_r_about = /** @type {(inputs: Mk_Nav_R_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentang kami`)
};

/**
* | output |
* | --- |
* | "About us" |
*
* @param {Mk_Nav_R_AboutInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_r_about = /** @type {((inputs?: Mk_Nav_R_AboutInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_R_AboutInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_r_about(inputs)
	return en_mk_nav_r_about(inputs)
});